/**
 *   Generated file. Do not edit
 */

export const ResourceMetaData = {
  '/group/{groupId}/name': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'string',
        maxLength: 16,
      },
    },
  },

  '/group/{groupId}/session-lifetime': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'integer',
        format: 'uint16',
        minimum: 1,
      },
    },
  },

  '/group/{groupId}/alias': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: true,
      schema: {
        type: 'integer',
        format: 'uint16',
      },
    },
  },
};
